/* src/app/modules/expense/expense-tabs.component.scss */
/*# sourceMappingURL=expense-tabs.component.css.map */
